import { authFetch } from "./base";
export const fetchConfig = async () => {
    const response = await authFetch('api/config/');
    return await response.json();
};
export const isTranslationProfileCustomPromptSupported = (profiles, profileId) => {
    if (!profileId) {
        return false;
    }
    const profile = profiles.find((item) => item.id === profileId);
    return profile?.customPromptSupport ?? false;
};
